module.exports = __webpack_public_path__ + "img/refraction-water-sphere.05a26a67.png";